import { ETrafficVolume, TRAFFIC_VOLUME_LABEL } from '@safesystem/client-playbook-lib';

// `aadt_band` stores the playbook's TRAFFIC_VOLUME_LABEL text (e.g. "<2,000"), so map it back to the enum.
export const aadtFromLabel = (label: unknown) =>
	Object.values(ETrafficVolume).find((volume) => TRAFFIC_VOLUME_LABEL[volume] === label);
